'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('invited-user-list', {
      url: '/users/invited/:type',
      template: '<invited-user-list></invited-user-list>'
    });
}



// WEBPACK FOOTER //
// ./client/~ap/app/admin/invited-user-list/invited-user-list.routes.js